module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Frontmatter"
    }
  }, [_c('p', {
    staticClass: "fig-caption1a"
  }, [_vm._v("Cover: "), _c('b', [_vm._v("What was to become the South London subsidiary of LBL became synonymous with the production L, operating them for just short of 19 years. On 7 May 1988 Croydon’s L 250 (D250 FYM) and L 201 (D201 FYM) pass through Thornton Heath. Exemplifying the need for most South London garages’ Ls to share their routes with older types, a DMS can just be seen creeping up behind.")]), _vm._v(" "), _c('i', [_vm._v("Malc McDonald")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d77302f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Frontmatter.vue
// module id = 69
// module chunks = 0